var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import Swal from "sweetalert2";
import { fromEvent, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AgentService } from '../../../services/agent.service';
import { AuthService } from '../../../services/auth.service';
import { MatSnackBar } from '@angular/material';
var TIME_DISCONNECTION = 5000; //5 sec
var POLLING_INTERVAL = 5000; //5 sec
var SESSION_STATUS_ACK_TIMEOUT = 10000;
var UserAvailabilityComponent = /** @class */ (function () {
    function UserAvailabilityComponent(auth, agentService, translate, _snackBar) {
        this.auth = auth;
        this.agentService = agentService;
        this.translate = translate;
        this._snackBar = _snackBar;
        this.sessionStatusOutput = new EventEmitter();
        this.availabilityStatus = [
            { id: 1, name: "online" },
            { id: 2, name: "reserved" },
            { id: 4, name: "offline" },
            { id: 5, name: "undefined" }
        ];
        this.offlineSessionStatus = { id: 4, name: "offline" };
        this.loadingSessionStatus = { id: 5, name: "undefined" };
        this.agentQueueTypes = [];
        this.unlockButton = false;
        this._unsub$ = new Subject();
        this._pollingUnsub$ = new Subject();
        this._pendingSessionStatus = null;
        this._pendingSessionFallback = null;
        this._sessionStatusAckTimer = null;
        this.emptyQueueTooltip = this.translate.instant('admin.trobbitlive.module.agents.agentAvailability.emptyQueueTooltip');
    }
    UserAvailabilityComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.agentSocketIsListening();
        fromEvent(window, 'offline').pipe(takeUntil(this._unsub$)).subscribe(function (_) {
            _this.openSnackBar('Sin conexión a internet  ⚠️');
            _this.userSessionStatus = { id: 5, name: "undefined" };
            _this.agentService.agentSessionStatus = _this.userSessionStatus;
            _this.unlockButton = false;
            //Timeout: valida conexión real antes de forzar reload
            //Solo recarga si la pestaña está visible y sin conexión (evita recargas por suspensión de app en iOS/móvil)
            var timeoutId = setTimeout(function () {
                if (!navigator.onLine && document.visibilityState === 'visible') {
                    window.location.reload();
                }
            }, TIME_DISCONNECTION);
            fromEvent(window, 'online').pipe(takeUntil(_this._unsub$)).subscribe(function (_) {
                _this._snackBar.dismiss();
                clearTimeout(timeoutId);
                _this.initSessionStatus(_this.loadingSessionStatus);
            });
        });
        this.initSessionStatus(this.loadingSessionStatus);
    };
    UserAvailabilityComponent.prototype.ngOnDestroy = function () {
        this.clearPendingSessionStatus();
        this._pollingUnsub$.next(true);
        this._pollingUnsub$.complete();
        this._unsub$.next(true);
        this._unsub$.complete();
    };
    UserAvailabilityComponent.prototype.initSessionStatus = function (userSessionStatus) {
        var _this = this;
        this.unlockButton = false;
        this.role = this.auth.user.role.id;
        this.userSessionStatus = userSessionStatus;
        if (this.role === 5) {
            this.agentId = this.auth.user.id;
            // Red de seguridad: el estado real solo llega por broadcast del socket. Si esa
            // respuesta se pierde (handshake, reconexion), sin este polling el widget queda
            // en "cargando" para siempre y el boton nunca se habilita. El primer tick sale
            // recien a POLLING_INTERVAL, asi que no reintroduce la carrera de 122c0297.
            // NO BORRAR: se perdio una vez en un merge de reconciliacion (ab3faac5).
            this.startSessionPolling();
            this.agentService.getAgent(this.agentId)
                .subscribe(function (agent) {
                if (agent && agent.queues && agent.queues.length > 0) {
                    _this.agentQueueTypes = agent.queues;
                    _this.unlockButton = true;
                }
            }, function (error) { return console.error('[initSessionStatus] Error obteniendo agente:', error); });
        }
    };
    UserAvailabilityComponent.prototype.changeSessionStatus = function (status) {
        return __awaiter(this, void 0, void 0, function () {
            var currentStatusId, emitted, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentStatusId = this.userSessionStatus ? this.userSessionStatus.id : null;
                        if (!(currentStatusId !== status.id || currentStatusId === 5)) return [3 /*break*/, 4];
                        if (status.id === 4)
                            return [2 /*return*/, this.showSessionStatusAlert()];
                        this.beginPendingSessionStatus(status);
                        this.startSessionPolling(); // Reset polling clock to avoid race condition with immediate poll
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.agentService.setSessionStatus({ agentId: this.agentId, sessionStatus: status })];
                    case 2:
                        emitted = _a.sent();
                        if (emitted === false)
                            this.rollbackPendingSessionStatus();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error('[changeSessionStatus] Error cambiando estado de sesión:', error_1);
                        this.rollbackPendingSessionStatus();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserAvailabilityComponent.prototype.showSessionStatusAlert = function () {
        var _this = this;
        Swal.fire({
            title: "" + this.translate.instant('admin.trobbitlive.module.agents.agentAvailability.onChangeOfflineTitle'),
            html: " <p>" + this.translate.instant('admin.trobbitlive.module.agents.agentAvailability.onChangeOffline') + ".</p>\n              <p>" + this.translate.instant('admin.trobbitlive.conversations.closeAllConfirmation') + "</p>",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#01BEFF',
            cancelButtonColor: '#AAAAAA',
            confirmButtonText: 'Aceptar',
            cancelButtonText: "Cancelar"
        }).then(function (result) { return __awaiter(_this, void 0, void 0, function () {
            var emitted, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!result.value) return [3 /*break*/, 4];
                        this.beginPendingSessionStatus(this.offlineSessionStatus);
                        this.startSessionPolling(); // Reset polling clock to avoid race condition with immediate poll
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.agentService.setSessionStatus({ agentId: this.agentId, sessionStatus: this.offlineSessionStatus })];
                    case 2:
                        emitted = _a.sent();
                        if (emitted === false)
                            this.rollbackPendingSessionStatus();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        console.error('[showSessionStatusAlert] Error cambiando estado de sesión:', error_2);
                        this.rollbackPendingSessionStatus();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    UserAvailabilityComponent.prototype.capitalizeFirstletter = function (string) {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    };
    UserAvailabilityComponent.prototype.agentSocketIsListening = function () {
        var _this = this;
        this.agentService.agentSessionStatus$.pipe(takeUntil(this._unsub$)).subscribe(function (sessionStatus) {
            _this.applyResolvedSessionStatus(sessionStatus);
        });
    };
    UserAvailabilityComponent.prototype.beginPendingSessionStatus = function (status) {
        var _this = this;
        var currentServiceStatus = this.agentService.agentSessionStatus;
        var previousStatus = this.userSessionStatus && this.userSessionStatus.id !== 5
            ? this.userSessionStatus
            : currentServiceStatus;
        this.clearPendingSessionStatus();
        this._pendingSessionStatus = status;
        this._pendingSessionFallback = previousStatus && previousStatus.id !== 5
            ? previousStatus
            : this.offlineSessionStatus;
        this.sessionStatusOutput.emit(this.loadingSessionStatus);
        this.userSessionStatus = this.loadingSessionStatus;
        this.unlockButton = false;
        this._sessionStatusAckTimer = setTimeout(function () {
            _this.rollbackPendingSessionStatus();
        }, SESSION_STATUS_ACK_TIMEOUT);
    };
    UserAvailabilityComponent.prototype.rollbackPendingSessionStatus = function () {
        if (!this._pendingSessionStatus)
            return;
        var fallbackStatus = this._pendingSessionFallback || this.offlineSessionStatus;
        this.clearPendingSessionStatus();
        this.applyResolvedSessionStatus(fallbackStatus);
        this.agentService.agentSessionStatus = fallbackStatus;
    };
    UserAvailabilityComponent.prototype.clearPendingSessionStatus = function () {
        if (this._sessionStatusAckTimer) {
            clearTimeout(this._sessionStatusAckTimer);
            this._sessionStatusAckTimer = null;
        }
        this._pendingSessionStatus = null;
        this._pendingSessionFallback = null;
    };
    UserAvailabilityComponent.prototype.applyResolvedSessionStatus = function (sessionStatus) {
        if (!sessionStatus)
            return;
        if (this._pendingSessionStatus && sessionStatus.id !== 5) {
            this.clearPendingSessionStatus();
        }
        this.sessionStatusOutput.emit(sessionStatus);
        this.userSessionStatus = sessionStatus;
        this.unlockButton = this.hasAgentQueues() && sessionStatus.id !== 5;
    };
    UserAvailabilityComponent.prototype.hasAgentQueues = function () {
        return this.agentQueueTypes && this.agentQueueTypes.length > 0;
    };
    /**
     * Polling continuo que envía el estado id 5 (undefined) al servidor
     * para obtener de vuelta la sesión real del agente y mantenerla actualizada.
     * Inicia con un delay de POLLING_INTERVAL para evitar que el primer tick
     * colisione con un cambio de estado manual en curso (race condition).
     */
    UserAvailabilityComponent.prototype.startSessionPolling = function () {
        var _this = this;
        this._pollingUnsub$.next(true);
        timer(POLLING_INTERVAL, POLLING_INTERVAL).pipe(takeUntil(this._pollingUnsub$), takeUntil(this._unsub$)).subscribe(function () {
            _this.agentService.setSessionStatus({ agentId: _this.agentId, sessionStatus: _this.loadingSessionStatus })
                .catch(function (error) { return console.error('[startSessionPolling] Error en polling de estado:', error); });
        });
    };
    UserAvailabilityComponent.prototype.openSnackBar = function (message) {
        this._snackBar.open(message, null, {
            duration: null,
        });
    };
    return UserAvailabilityComponent;
}());
export { UserAvailabilityComponent };
